import React from "react";
import { Formik, Form, FieldArray } from "formik";
import * as Yup from "yup";
import {
  Grid,
  TextField,
  Button,
  Typography,
  IconButton,Box
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

const ExperienceDetailEditForm = ({ userDetails, onCancel, onSave }) => {
  const initialValues = {
    id: userDetails.id,
    profile: {
      experience: userDetails?.profile_data?.experience?.length
        ? userDetails.profile_data.experience
        : [
            {
              company: "",
              joining: "",
              end: "",
              designation: "",
            },
          ],
    },
  };

  const validationSchema = Yup.object().shape({
    profile: Yup.object().shape({
      experience: Yup.array().of(
        Yup.object().shape({
          company: Yup.string().required("Required"),
          joining: Yup.string().required("Required"),
          end: Yup.string().required("Required"),
          designation: Yup.string().required("Required"),
        })
      ),
    }),
  });

  const handleSubmit = (values) => {
    onSave(values);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {({ values, handleChange, handleBlur, errors, touched }) => (
        <Form>
          <FieldArray name="profile.experience">
            {({ push, remove }) => (
              <>
                {values.profile.experience.map((exp, index) => (
                  <Grid
                    container
                    spacing={2}
                    key={index}
                    sx={{ mb: 2, borderBottom: "1px solid #ccc", pb: 2 }}
                  >
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Company Name"
                        name={`profile.experience[${index}].company`}
                        value={exp.company}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.profile?.experience?.[index]?.company &&
                          Boolean(errors.profile?.experience?.[index]?.company)
                        }
                        helperText={
                          touched.profile?.experience?.[index]?.company &&
                          errors.profile?.experience?.[index]?.company
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Designation"
                        name={`profile.experience[${index}].designation`}
                        value={exp.designation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.profile?.experience?.[index]?.designation &&
                          Boolean(
                            errors.profile?.experience?.[index]?.designation
                          )
                        }
                        helperText={
                          touched.profile?.experience?.[index]?.designation &&
                          errors.profile?.experience?.[index]?.designation
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        type="date"
                        label="Joining Date"
                        name={`profile.experience[${index}].joining`}
                        value={exp.joining}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        InputLabelProps={{ shrink: true }}
                        error={
                          touched.profile?.experience?.[index]?.joining &&
                          Boolean(errors.profile?.experience?.[index]?.joining)
                        }
                        helperText={
                          touched.profile?.experience?.[index]?.joining &&
                          errors.profile?.experience?.[index]?.joining
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        type="date"
                        label="End Date"
                        name={`profile.experience[${index}].end`}
                        value={exp.end}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        InputLabelProps={{ shrink: true }}
                        error={
                          touched.profile?.experience?.[index]?.end &&
                          Boolean(errors.profile?.experience?.[index]?.end)
                        }
                        helperText={
                          touched.profile?.experience?.[index]?.end &&
                          errors.profile?.experience?.[index]?.end
                        }
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <IconButton
                        onClick={() => remove(index)}
                        disabled={values.profile.experience.length === 1}
                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}

                <Button
                  startIcon={<AddIcon />}
                  variant="outlined"
                  onClick={() =>
                    push({
                      company: "",
                      joining: "",
                      end: "",
                      designation: "",
                    })
                  }
                  sx={{ mb: 2 }}
                >
                  Add Experience
                </Button>
              </>
            )}
          </FieldArray>

          {/* Buttons */}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
              <Button variant="outlined" onClick={onCancel}>
                Cancel
              </Button>
              <Button variant="contained" color="primary" type="submit">
                Save
              </Button>
              
            </Box>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default ExperienceDetailEditForm;
